import { injectable } from 'inversify'
import type { AxiosRequestConfig } from 'axios'
import type { HttpInterceptor } from '@/services/transport/types'

@injectable()
export default class AppVersionInterceptor implements HttpInterceptor {
  public request(config: AxiosRequestConfig): AxiosRequestConfig {
    const appVersionHeader = 'X-App-Version'
    const appVersion = APP_VERSION

    if (appVersion) {
      config.headers = config.headers ?? {}
      config.headers[appVersionHeader] = appVersion
    }
    return config
  }
}
